<template>
  <Dialog
    :visible="visible"
    modal
    header="Remove captain status"
    :style="{ width: '28rem' }"
    :breakpoints="{ '575px': 'calc(100vw - 2rem)' }"
    :closable="false"
  >
    <p class="kb-dialog-lead">
      Changing the member type removes <strong>{{ member.name || 'this member' }}</strong>
      as captain of <strong>{{ subkrewe?.name || 'their SubKrewe' }}</strong>.
    </p>
    <p class="kb-dialog-lead text-kb-muted">
      {{ pendingType === 'member'
        ? 'They stay a member of the SubKrewe.'
        : 'They leave the SubKrewe completely.' }}
    </p>
    <template #footer>
      <Button
        label="Cancel"
        text
        severity="secondary"
        @click="$emit('response', false)"
      />
      <Button
        label="Remove as captain"
        severity="danger"
        @click="$emit('response', true)"
      />
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import type { Member } from '~/shared/types/member'
import type { SubKrewe } from '~/shared/types/subkrewe'

interface Props {
  visible: boolean
  member: Member
  subkrewe: SubKrewe | null
  pendingType: 'member' | 'redshirt' | null
}

defineProps<Props>()
defineEmits(['response', 'update:visible'])
</script>
